<template>
    <b-container fluid>
        <b-row>
            <b-col class="font-weight-bold pt-0" cols="4">Comments:</b-col>
            <b-col>{{ checkoff.comments || 'No Comments' }}</b-col>
        </b-row>
        <b-row>
            <b-col class="font-weight-bold pt-0" cols="4">Submiited By:</b-col>
            <b-col>{{ checkoff.user | filterName }}</b-col>
        </b-row>
        <b-row>
            <b-col class="font-weight-bold pt-0" cols="4">Email:</b-col>
            <b-col>{{ checkoff.user.email }}</b-col>
        </b-row>
    </b-container>
</template>


<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-ViewCheckoffSummary',
    mixins: [permissionsMixins],
    props: ['checkoff'],
    filters: {
        filterName(user) {
            return user.first_name + ' ' + user.last_name
        },
    },
}
</script>